import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice";
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"restaurant App Development",
      slug:""
    },
  ]
}

export default function RestaurantBanner() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="pharm-banner restro-banner header-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="pharm-banner-details">

                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <span className='purple-gradiant'>Ai-Powered</span>
                <h1 className="heading"><small>Beyond Simple</small>
                <span className='gradiant-color'> reservations</span></h1>
                <p>Mobility Infotech empowers restaurants to boost sales, enhance guest satisfaction, and ensure repeat visits—effortlessly.</p>
                <label>21 Days Free Trial | No Credit Card Required</label>
                <Link onClick={() => dispatch(openPopup())} className='default-btn'>Get A demo</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row justify-content-between">
            <div className="col-lg-6 col-md-6 col-xxl-7">
            </div>
            <div className="col-lg-6 col-md-6 col-xxl-5">
              <div className="pharm-banner-image wow animate__animated animate__slideInRight" data-wow-delay="0.2s" data-wow-duration="1.2s">
                <img src="./assets/home/restro-banner-img.webp" alt="banner" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
